import React, { Component } from "react";
import { Button } from "react-bootstrap";
import i18n from "i18next";
import PropTypes from "prop-types";

export default class AddSoundProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  render() {
    const { hide, setAddSoundVisible, formControlProps } = this.props;
    const label = formControlProps ? formControlProps.label : i18n.t("Sound.addSound");

    return (
      <div style={{ display: hide ? "none" : "block" }}>
        <Button
          className="toolbarButton"
          onClick={() => {
            this.setState({ open: !this.state.open });
            setAddSoundVisible();
          }}
        >
          <i className="toolbarIcons material-icons">music_note</i>
          {label}
        </Button>
      </div>
    );
  }
}

AddSoundProvider.propTypes = {
  formControlProps: PropTypes.object,
  value: PropTypes.any,
  id: PropTypes.any,
  hide: PropTypes.bool,
  setAddSoundVisible: PropTypes.func,
};
